import React, { useState } from 'react';
import './QuickNavigationSection.styles.scss';
import 'primeicons/primeicons.css';

const QuickNavigationSection: React.FC = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  const navigationItems = [
    { icon: '🔝', label: 'Overview', target: '.molecule-header' },
    { icon: '💊', label: 'Products', target: '#available-strengths' },
    { icon: '📄', label: 'ANDA Info', target: '#anda-information' },
    { icon: '📊', label: 'Market Insights', target: '#market-insights' },
    // { icon: '📋', label: 'Regulatory', target: '#regulatory-overview' },
  ];

  const handleNavigationClick = (target: string) => {
    const element = document.querySelector(target);

    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });

      // Add highlight effect
      (element as HTMLElement).style.outline = '2px solid var(--primary-color)';
      (element as HTMLElement).style.outlineOffset = '4px';

      setTimeout(() => {
        (element as HTMLElement).style.outline = '';
        (element as HTMLElement).style.outlineOffset = '';
      }, 2000);
    } else {
      // Fallback: try to find any section with similar content
      const fallbackElement = document.querySelector(
        `[id*="${target.replace('#', '').replace('-', '')}"]`
      );
      if (fallbackElement) {
        fallbackElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }
    }
  };

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className={`quick-nav ${isExpanded ? 'expanded' : 'collapsed'}`}>
      <div className="quick-nav-header">
        {isExpanded && <h4>Quick Jump</h4>}
        <button className="quick-nav-toggle" onClick={toggleExpand} aria-label="Toggle navigation">
          <i className={`pi ${isExpanded ? 'pi-times' : 'pi-bars'}`}></i>
        </button>
      </div>
      {isExpanded && (
        <div className="quick-nav-content">
          {navigationItems.map((item, index) => (
            <button
              key={index}
              className="quick-nav-item"
              onClick={() => {
                handleNavigationClick(item.target);
                // Optionally collapse after navigation
                // setIsExpanded(false);
              }}
            >
              {item.icon} {item.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default QuickNavigationSection;
